import * as actionTypes from '../../actions/actionTypes';

export const initialState = {
  user: null,
  loading: false,
  error: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.auth.AUTH_LOADING:
      return {
        ...state,
        loading: true,
        error: ''
      };
    case actionTypes.auth.AUTH_SUCCESS:

      return {
        ...state,
        loading: false,
        user: action.user,
        unauthenticatedUser: null
      }
    case actionTypes.auth.AUTH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    default:
      return state;
  }
};

export default reducer;